import Vue from 'vue';
import Modals from './Modals.vue';
import { getPiniaInstance } from '../../store/page-store';
import TransFilter from '../../../qaamgo/modules/sat/components/mixins/TransFilter.vue'

Vue.mixin(TransFilter);

new Vue({
    el: '#qg-modal',
    name: 'modalsRoot',
    components: { Modals },
    pinia: getPiniaInstance(),
    render(h) {
        return h(Modals);
    },
});
